import { render, staticRenderFns } from "./textDocument.vue?vue&type=template&id=d502397a&scoped=true"
import script from "./textDocument.vue?vue&type=script&lang=js"
export * from "./textDocument.vue?vue&type=script&lang=js"
import style0 from "./textDocument.vue?vue&type=style&index=0&id=d502397a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d502397a",
  null
  
)

export default component.exports